'use strict';

var keyMirror = require('react/lib/keyMirror');

var NativeDragItemTypes = {
  FILE: '__NATIVE_FILE__'
};

module.exports = NativeDragItemTypes;


/*****************
 ** WEBPACK FOOTER
 ** ../modules/constants/NativeDragItemTypes.js
 ** module id = 75
 ** module chunks = 0
 **/